import React, { useState, useEffect } from 'react';
import API from '../utils/api';

export default function Dashboard() {
  const [tasks, setTasks] = useState([]);
  const [dailyTasks, setDailyTasks] = useState([]);
  const [time, setTime] = useState(new Date());
  const [stats, setStats] = useState({ urgent:0, high:0, doing:0, done:0, dailyDone:0, dailyTotal:0 });

  const fetchData = async () => {
    try {
      const [taskRes, dailyRes, reviewRes] = await Promise.all([
        API.get('/tasks', { params: { dashboard_all: '1' } }),
        API.get('/daily', { params: { dashboard_all: '1' } }),
        API.get('/property-archive/review-tasks').catch(() => ({data:[]}))
      ]);
      const t = [...reviewRes.data, ...taskRes.data];
      const d = dailyRes.data;
      setTasks(t);
      setDailyTasks(d);
      setStats({
        urgent: t.filter(x => x.priority==='紧急' && x.status!=='已完成').length,
        high: t.filter(x => x.priority==='高' && x.status!=='已完成').length,
        doing: t.filter(x => x.status==='处理中').length,
        done: t.filter(x => x.status==='已完成').length,
        dailyDone: d.filter(x => x.status==='已完成').length,
        dailyTotal: d.length,
      });
    } catch (err) { console.error(err); }
  };

  useEffect(() => {
    fetchData();
    const dataTimer = setInterval(fetchData, 30000);
    const clockTimer = setInterval(() => setTime(new Date()), 1000);
    return () => { clearInterval(dataTimer); clearInterval(clockTimer); };
  }, []);

  const weeks = ['日','一','二','三','四','五','六'];
  const timeStr = `${String(time.getHours()).padStart(2,'0')}:${String(time.getMinutes()).padStart(2,'0')}:${String(time.getSeconds()).padStart(2,'0')}`;
  const dateStr = `${time.getFullYear()}年${time.getMonth()+1}月${time.getDate()}日 星期${weeks[time.getDay()]}`;

  const PRIORITY_COLORS = { '紧急':'#ff4d4f', '高':'#ff7a45', '中':'#1890ff', '低':'#52c41a' };
  const STATUS_COLORS = { '待处理':'#ff4d4f', '处理中':'#1890ff', '已完成':'#52c41a', '已超时':'#ff4d4f' };

  const pendingTasks = tasks.filter(t => t.status !== '已完成');
  const completedTasks = tasks.filter(t => t.status === '已完成').slice(0, 5);

  const getDailyStatus = (t) => {
    if (t.status === '已完成') return { text: '✓ 已完成', color: '#52c41a', bg: 'rgba(82,196,26,0.15)' };
    if (t.status === '已超时') return { text: '⚠ 超时', color: '#ff4d4f', bg: 'rgba(255,77,79,0.15)' };
    return { text: '⏳ 待完成', text2: t.scheduled_time, color: '#fa8c16', bg: 'rgba(250,140,22,0.15)' };
  };

  return (
    <div style={s.page}>
      {/* 顶部 */}
      <div style={s.header}>
        <div style={s.headerLeft}>
          <span style={{fontSize:'28px'}}>☁️</span>
          <div>
            <div style={s.companyName}>云彩环境 物业管理</div>
            <div style={s.subName}>大诚瓯江印象 · 管理看板 · <span style={{color:'#52c41a'}}>●</span> 实时更新</div>
          </div>
        </div>
        <div style={s.clockArea}>
          <div style={s.clock}>{timeStr}</div>
          <div style={s.date}>{dateStr}</div>
        </div>
      </div>

      {/* 统计行 */}
      <div style={s.statsRow}>
        {[
          { num: stats.urgent, label: '紧急事项', color: '#ff4d4f', icon: '🔴' },
          { num: stats.high, label: '高优先级', color: '#ff7a45', icon: '🟠' },
          { num: stats.doing, label: '处���中', color: '#1890ff', icon: '🔵' },
          { num: stats.done, label: '已完成', color: '#52c41a', icon: '🟢' },
          { num: `${stats.dailyDone}/${stats.dailyTotal}`, label: '今日任务', color: '#ffd666', icon: '✅' },
          { num: stats.dailyTotal > 0 ? Math.round(stats.dailyDone/stats.dailyTotal*100)+'%' : '0%', label: '完成率', color: '#36cfc9', icon: '📊' },
        ].map((item, i) => (
          <div key={i} style={s.statCard}>
            <div style={{...s.statNum, color: item.color}}>{item.num}</div>
            <div style={s.statLabel}>{item.icon} {item.label}</div>
          </div>
        ))}
      </div>

      {/* 主内容区 */}
      <div style={s.mainGrid}>
        {/* 左：待办事项 */}
        <div style={s.card}>
          <div style={{...s.cardHeader, borderLeftColor:'#1890ff'}}>
            <span style={s.cardIcon}>📋</span>
            <span style={s.cardTitle}>待办事项</span>
            <span style={s.cardBadge}>{pendingTasks.length} 件待处理</span>
          </div>
          <div style={s.scrollArea}>
            {pendingTasks.length === 0 ? (
              <div style={s.empty}>暂无待处理事项 🎉</div>
            ) : pendingTasks.map(t => (
              <div key={t.id} style={s.taskItem}>
                <div style={{...s.priorityDot, background: PRIORITY_COLORS[t.priority], boxShadow: t.priority==='紧急'?`0 0 8px ${PRIORITY_COLORS[t.priority]}`:'none'}} />
                <div style={s.taskContent}>
                  <div style={s.taskTitle}>{t.title}</div>
                  <div style={s.taskMeta}>
                    📍 {t.task_type==='property_review' ? (t.review_room_no || t.public_area) : (t.location_type==='住宅' ? `${t.building}${t.unit}${t.floor}层${t.room}室` : t.public_area)}
                    　{t.department && `· ${t.department}`}
                  </div>
                </div>
                <div style={{...s.statusTag, background: STATUS_COLORS[t.status]+'22', color: STATUS_COLORS[t.status], border: `1px solid ${STATUS_COLORS[t.status]}44`}}>
                  {t.status}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 右：今日任务 */}
        <div style={s.card}>
          <div style={{...s.cardHeader, borderLeftColor:'#fa8c16'}}>
            <span style={s.cardIcon}>✅</span>
            <span style={s.cardTitle}>今日任务</span>
            <span style={s.cardBadge}>{stats.dailyDone}/{stats.dailyTotal} 已完成</span>
          </div>
          {/* 进度条 */}
          <div style={s.progressWrap}>
            <div style={s.progressBg}>
              <div style={{...s.progressFill, width: stats.dailyTotal > 0 ? `${Math.round(stats.dailyDone/stats.dailyTotal*100)}%` : '0%'}} />
            </div>
            <span style={s.progressPct}>{stats.dailyTotal > 0 ? Math.round(stats.dailyDone/stats.dailyTotal*100) : 0}%</span>
          </div>
          <div style={s.scrollArea}>
            {dailyTasks.length === 0 ? (
              <div style={s.empty}>今日暂���任务</div>
            ) : dailyTasks.map(t => {
              const st = getDailyStatus(t);
              return (
                <div key={t.id} style={s.dailyItem}>
                  <div style={s.dailyTime}>{t.scheduled_time}</div>
                  <div style={s.dailyTitle}>{t.title}</div>
                  <div style={s.dailyDept}>{t.department || t.assign_user_name}</div>
                  <div style={{...s.dailyStatus, color: st.color, background: st.bg}}>
                    {st.text}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* 底部跑马灯 */}
      <div style={s.ticker}>
        <div style={s.tickerInner}>
          {[
            `📋 待处理事项 ${pendingTasks.length} 件，其中紧急 ${stats.urgent} 件`,
            `✅ 今日任务完成 ${stats.dailyDone}/${stats.dailyTotal} 件`,
            `🏢 云彩环境 物业管理 · 大诚瓯江印象 · 让每一栋���都被用心管理`,
            `📋 待处理事项 ${pendingTasks.length} 件，其中紧急 ${stats.urgent} 件`,
            `✅ 今日任务完成 ${stats.dailyDone}/${stats.dailyTotal} 件`,
            `🏢 云彩环境 物业管理 · 大诚瓯江印象 · 让每一栋楼都被用心管理`,
          ].map((text, i) => <span key={i} style={s.tickerItem}>{text}</span>)}
        </div>
      </div>

      <style>{`
        @keyframes ticker { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        @keyframes scroll { 0% { transform: translateY(0); } 100% { transform: translateY(-50%); } }
        .scroll-area-inner { animation: scroll 30s linear infinite; }
        .scroll-area-inner:hover { animation-play-state: paused; }
      `}</style>
    </div>
  );
}

const s = {
  page: { height: '100vh', background: '#0a1628', color: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden', fontFamily: "-apple-system,'PingFang SC','Microsoft YaHei',sans-serif" },
  header: { background: 'linear-gradient(90deg, #0d2246, #1a4a8a, #0d2246)', padding: '10px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(45,125,210,0.4)', flexShrink: 0 },
  headerLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  companyName: { fontSize: '20px', fontWeight: 800, letterSpacing: '2px' },
  subName: { fontSize: '12px', color: '#7ab3e0', marginTop: '2px' },
  clockArea: { textAlign: 'right' },
  clock: { fontSize: '28px', fontWeight: 800, color: '#52c8ff', letterSpacing: '2px', fontVariantNumeric: 'tabular-nums' },
  date: { fontSize: '12px', color: '#7ab3e0', marginTop: '2px' },
  statsRow: { display: 'flex', gap: '10px', padding: '10px 16px', flexShrink: 0 },
  statCard: { flex: 1, background: 'linear-gradient(135deg, #0d2246, #112a50)', borderRadius: '10px', padding: '10px', textAlign: 'center', border: '1px solid rgba(45,125,210,0.2)' },
  statNum: { fontSize: '26px', fontWeight: 900, lineHeight: 1, marginBottom: '4px' },
  statLabel: { fontSize: '11px', color: '#7ab3e0' },
  mainGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', padding: '0 16px', flex: 1, overflow: 'hidden' },
  card: { background: 'linear-gradient(135deg, #0d2246, #112a50)', borderRadius: '12px', border: '1px solid rgba(45,125,210,0.2)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  cardHeader: { padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', borderBottom: '1px solid rgba(45,125,210,0.15)', borderLeft: '3px solid #1890ff', flexShrink: 0 },
  cardIcon: { fontSize: '16px' },
  cardTitle: { fontSize: '14px', fontWeight: 700, letterSpacing: '1px', color: '#e0f0ff' },
  cardBadge: { marginLeft: 'auto', fontSize: '11px', background: 'rgba(45,125,210,0.25)', padding: '2px 8px', borderRadius: '10px', color: '#7ab3e0' },
  scrollArea: { flex: 1, overflow: 'hidden', padding: '6px 12px' },
  empty: { textAlign: 'center', padding: '30px', color: '#4a6080', fontSize: '14px' },
  taskItem: { display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' },
  priorityDot: { width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0 },
  taskContent: { flex: 1, overflow: 'hidden' },
  taskTitle: { fontSize: '13px', color: '#d0e4f7', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  taskMeta: { fontSize: '11px', color: '#4a7090', marginTop: '2px' },
  statusTag: { padding: '2px 7px', borderRadius: '4px', fontSize: '10px', whiteSpace: 'nowrap', flexShrink: 0 },
  progressWrap: { display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', flexShrink: 0 },
  progressBg: { flex: 1, height: '6px', background: 'rgba(255,255,255,0.1)', borderRadius: '3px', overflow: 'hidden' },
  progressFill: { height: '100%', background: 'linear-gradient(90deg, #d46b08, #ffa940)', borderRadius: '3px', transition: 'width 0.5s' },
  progressPct: { fontSize: '12px', color: '#ffd666', fontWeight: 700, width: '36px', textAlign: 'right' },
  dailyItem: { display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.04)', fontSize: '12px' },
  dailyTime: { color: '#ffd666', width: '36px', flexShrink: 0, fontSize: '11px' },
  dailyTitle: { flex: 1, color: '#d0e4f7', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  dailyDept: { color: '#4a7090', fontSize: '11px', flexShrink: 0 },
  dailyStatus: { padding: '2px 7px', borderRadius: '4px', fontSize: '10px', whiteSpace: 'nowrap', flexShrink: 0 },
  ticker: { background: 'linear-gradient(90deg, #0d2246, #1a4a8a, #0d2246)', borderTop: '1px solid rgba(45,125,210,0.3)', padding: '5px 0', overflow: 'hidden', flexShrink: 0 },
  tickerInner: { display: 'flex', gap: '60px', animation: 'ticker 25s linear infinite', whiteSpace: 'nowrap', fontSize: '12px', color: '#7ab3e0' },
  tickerItem: { display: 'inline-flex', alignItems: 'center', gap: '4px' },
};
